/**
 * Remembers which studio somebody was last looking at, the way
 * `environment.tsx` remembers which environment (`mw:env:{projectId}`) — this
 * follows that precedent exactly, one level up.
 *
 * There is exactly one "current studio" at a time, not one per anything else,
 * so the key carries no id of its own: `mw:org`, never `mw:org:{orgId}`.
 *
 * A separate module from `org.ts` on purpose — decisions/0038's landing rule
 * needs this, and `org.ts` is mid-edit elsewhere for the resolution order
 * itself. The two do not overlap: this only ever writes and reads a browser
 * value, `org.ts` decides what an id means.
 */

export function rememberStudio(orgId: string | undefined): void {
  if (!orgId) return;
  try {
    localStorage.setItem("mw:org", orgId);
  } catch {
    // A browser with site data blocked still navigates; it just forgets.
  }
}

export function rememberedStudio(): string | undefined {
  try {
    return localStorage.getItem("mw:org") ?? undefined;
  } catch {
    return undefined;
  }
}

// A per-studio last-game (`mw:project:{orgId}`) would follow the same
// precedent, but nothing in this packet has both ids in hand without adding a
// fetch a layout has no other reason to make — `OrgLayout` in `layouts.tsx`
// deliberately fetches nothing. Landing only ever needs the studio, so that
// is all this file keeps.
